import React from "react";
import ImageHeader from "../assets/images/headerImage.png";
export default function Header() {
  return (
    <div className="header-container">
      <img src={ImageHeader} />
    </div>
  );
}
